module.exports = __webpack_public_path__ + "static/img/introduceContent3.fd226f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduceContent3.png
// module id = Y/b8
// module chunks = 0